<template lang="pug">
    include /@ibkr/lib.common/src/icon/basic
    div(class="outsety-4")
        ib-row
            ib-col(class="s12 m12 l12 xl6")
                ib-form
                    ib-field(class="search-field", v-model="curSearch", :placeholder="this.$t('search_by_company') + '/' + this.$t('ticker')", @input="checkValidation(curSearch)")
                    span(@click="clearField(true)", class="bg15-inverse cancel")
                        +icon-basic-cancel
                    button(@click="submit", class="magnify")
                        +icon-basic-search_filled
</template>
<script>
    import { mapState, mapActions, mapGetters } from 'vuex';
    import api from '../api/';

    export default {
        name: 'SearchTerm',
        data() {
            return {
                curSearch: '',
                // ids: [],
                invalidInput: false,
                options: { limit: 50, 'page': 1}
            }
        },
        methods: {
            submit() {
                console.debug('Searching ids...');
                // For particular queries, we want to set a particular result. Otherwise query db.
                let ids = this.checkPhrase(this.curSearch);

                if (ids.length > 1) {
                    this.setIds(ids);
                    this.searchIds()
                        .catch(err => {
                            console.error(err);
                        })
                } else {
                    api.getCompanies(this.curSearch, this.options, this.selectedAssetsTerm)
                    .then(response => {
                        console.debug({response});
                        this.setIds(response.res.map(item => item.id));
                        return this.searchIds(this.curSearch.toUpperCase())
                    })
                    .catch(error => {
                        console.error('Unable to search this...', this.curSearch);
                        $alert(this.$t('zero_results'), {tone: 'remove'});
                    });
                }
            },

            checkPhrase(search) {
                /*
                    -Fix for search of names like 'AT&T Inc' and single symbol tickers like 'T'. 
                    -Excluded Single letter Symbols 'I,N,P,Q,Z'
                */

                const searchPhrase = search.toUpperCase();
                let ids = [];
                if (searchPhrase === 'A') {
                    //Agilent Technologies Inc
                    ids.push(18541);
                } else if (searchPhrase === 'B') {
                    //Barnes Group Inc
                    ids.push(22983);
                } else if (searchPhrase === 'C') {
                    //Citigroup Inc
                    ids.push(15924);
                } else if (searchPhrase === 'D') {
                    //Dominion Energy Inc
                    ids.push(23164);
                } else if (searchPhrase === 'E') {
                    //Enterprise Group Inc
                    ids.push(24604);
                } else if (searchPhrase === 'F') {
                    //Ford Motor Company
                    ids.push(23183);
                } else if (searchPhrase === 'G') {
                    //Genpact Ltd
                    ids.push(6287);
                } else if (searchPhrase === 'H') {
                    //Hyatt Hotels Corporation
                    ids.push(7289);
                } else if (searchPhrase === 'J') {
                    //Jacobs Engineering Group Inc
                    ids.push(14749);
                } else if (searchPhrase === 'K') {
                    //Kellogg Company
                    ids.push(816);
                } else if (searchPhrase === 'L') {
                    //Loews Corporation
                    ids.push(849);
                } else if (searchPhrase === 'M' || searchPhrase.includes('MACY')) {
                    //Macy's Inc
                    ids.push(26970);
                } else if (searchPhrase === 'O' || searchPhrase.includes('REALTY')) {
                    //Realty Income Corp
                    ids.push(18502);
                } else if (searchPhrase === 'R') {
                    //Ryder System, Inc.
                    ids.push(27031);
                } else if (searchPhrase === 'S') {
                    //SentinelOne Inc
                   ids.push(4082);
                } else if (searchPhrase === 'T' || searchPhrase.includes('AT&')) {
                    //AT&T Inc.
                    ids.push(8433);
                } else if (searchPhrase === 'U') {
                    //Unity Software
                    ids.push(15702);
                } else if (searchPhrase === 'V') {
                    //Visa Inc
                    ids.push(6367);
                } else if (searchPhrase === 'W') {
                    //Wayfair Inc
                    ids.push(25841);
                } else if (searchPhrase === 'X') {
                    //United States Steel Corporation
                    ids.push(966);
                } else if (searchPhrase === 'Y') {
                    //Alleghany Corporation
                    ids.push(280);
                }

                return ids;
            },
            checkValidation(val) {
                this.invalidInput = /[^a-zA-Z,\\\\!['];\.\&\d\s:]/g.test(val) ? true : false;
                if (this.invalidInput) {
                    this.$alert(this.$t('use_proper_value'));
                    this.clearField(true);
                }
            },
            clearField(bool) {
                this.curSearch = '';
                this.setIds([]);
                this.setCurrentPage(1);
                this.search({'skipAvg:': false});
            },
            ...mapActions(['setIds', 'searchIds', 'search', 'setCurrentPage'])
        },
        computed: {
            placeholder() {
                return `Search`;
            },
            ...mapState(['assets', 'selectedCurrency', 'regions', 'sectors']),
            ...mapGetters(['selectedAssets', 'selectedMarketCaps', 'selectedAssetsTerm'])
        },
    }
</script>

<style scoped lang="less">
    .search-field {
        width: calc(100% - 62px);
        margin: 0 0 20px 0;
    }
    .cancel {
        display: inline-block;
        height: 31px;
        padding: 4px;
        margin-left: -3px;
        margin-bottom: 8px;
        width: 31px;
        border: 1px solid #d7d7d7;
        svg {
            color: #dcdcde;
        }
    }
    .magnify {
        height: 31px;
        width: 31px;
        border: 1px solid #D7D7D7;
        border-radius: 0 5px 5px 0px;
        background-color: #F7F7F7;
        position: relative;
        margin-bottom: 8px;
        top: 2px;
        svg {
            width: 100%;
            height: 1em;
        }
    }
</style>